module.exports = __webpack_public_path__ + "img/TSN_Available-sizes_bg.076f01dc.png";